<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Inventory'" [class]="'kt-portlet__head--lg'">

		<ng-container ktPortletTools *ngIf="role == 'sadmin'">
			<h4><span class="badge bg-warning rounded-pill text-dark">{{selectedMachine?.canister_type || 'Azkoyen'}}</span></h4>
		</ng-container>

	</kt-portlet-header>
	<div class="kt-portlet__body">
		<div class="row" >
			<div class="col mt-3 mb-3" *ngFor="let item of inventory">

				<div id="bean-holder" *ngIf="item.name == 'BEANS'">
					<div class="row justify-content-center">
						<h5>BEANS</h5>
					</div>
					<div class="row">
						<div class="keg-container mx-auto">
							<img class="keg-img" src="../../../../../assets/media/vendi/Canister_coffee_bg_1.png"/>
							<p class="keg-lbl text-center">{{calcInvLvl(item, 'inv')}}</p>
							<div class="flip keg-div">
							  <div id="keg-fill" [ngStyle]="{'height': calcInvLvl(item, 'inv'), 'background-color': item.colorBox}"></div>
							</div>
						</div>
					</div>
					<div class="row text-center">
						<div class="col">
							<div class="row mb-3">
								<span class="inventory-status-chip mx-auto" [ngClass]="getStatusColorClass(getInventoryStatus(item))">
									{{getInventoryStatus(item).toUpperCase()}}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div id="cream-holder" *ngIf="item.name == 'EMPTY'">
					<div class="row justify-content-center">
						<h5 >EMPTY</h5>
					</div>
					<div class="row">
						<div class="keg-container-cream mx-auto">
							<img class="keg-img-empty" src="../../../../../assets/media/vendi/Canister_empty.png"/>
							<!-- <p class="keg-lbl-cream text-center">{{calcInvLvl(item, 'inv')}}</p>
							<div class="flip keg-div-cream">
							  <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(item, 'inv'), 'background-color': item.colorBox}"></div>
							</div> -->
						</div>
					</div>
					<!-- <div class="row text-center">
						<div class="col">
							<div class="row mb-3">
								<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
							</div>
							<div class="row text-danger">
								<p class="mx-auto">EMPTY: {{calcInvLvl(item, 'empty')}}</p>
							</div>
							<div class="row text-warning">
								<p class="mx-auto">LOW  : {{calcInvLvl(item, 'low')}}</p>
							</div>
						</div>
					</div> -->
				</div>

				<div id="cream-holder" *ngIf="item.name != 'BEANS' && item.name != 'EMPTY'">
					<div class="row justify-content-center">
						<h5 >{{item.name}}</h5>
					</div>
					<div class="row">
						<div class="keg-container-cream mx-auto">
							<img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
							<p class="keg-lbl-cream text-center">{{calcInvLvl(item, 'inv')}}</p>
							<div class="flip keg-div-cream">
							  <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(item, 'inv'), 'background-color': item.colorBox}"></div>
							</div>
						</div>
					</div>
					<div class="row text-center">
						<div class="col">
							<div class="row mb-3">
								<span class="inventory-status-chip mx-auto" [ngClass]="getStatusColorClass(getInventoryStatus(item))">
									{{getInventoryStatus(item).toUpperCase()}}
								</span>
							</div>
						</div>
					</div>
				</div>

			</div>


			<!-- <div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >BEAN</h5>
				</div>
				<div class="row">
					<div class="keg-container mx-auto">
                        <img class="keg-img" src="../../../../../assets/media/vendi/Canister_coffee_bg_1.png"/>
                        <p class="keg-lbl text-center">{{calcInvLvl(inventory[0], 'inv')}}</p>
                        <div class="flip keg-div">
                          <div id="keg-fill" [ngStyle]="{'height': calcInvLvl(inventory[0], 'inv'), 'background-color': '#A2784F'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" (click)="onEdit(inventory[0])" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[0], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[0], 'low')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >FV CREAM</h5>
				</div>
				<div class="row">
					<div class="keg-container-cream mx-auto">
                        <img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
                        <p class="keg-lbl-cream text-center">{{calcInvLvl(inventory[1], 'inv')}}</p>
                        <div class="flip keg-div-cream">
                          <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(inventory[1], 'inv'), 'background-color': '#F5E7B9'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[1], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[1], 'low')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >COCOA</h5>
				</div>
				<div class="row">
					<div class="keg-container-cream mx-auto">
                        <img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
                        <p class="keg-lbl-cream text-center">{{calcInvLvl(inventory[2], 'inv')}}</p>
                        <div class="flip keg-div-cream">
                          <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(inventory[2], 'inv'), 'background-color': '#814537'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[2], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[2], 'low')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >MILK</h5>
				</div>
				<div class="row">
					<div class="keg-container-cream mx-auto">
                        <img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
                        <p class="keg-lbl-cream text-center">{{calcInvLvl(inventory[3], 'inv')}}</p>
                        <div class="flip keg-div-cream">
                          <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(inventory[3], 'inv'), 'background-color': '#F5E4CE'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[3], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[3], 'low')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >CHAI</h5>
				</div>
				<div class="row">
					<div class="keg-container-cream mx-auto">
                        <img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
                        <p class="keg-lbl-cream text-center">{{calcInvLvl(inventory[4], 'inv')}}</p>
                        <div class="flip keg-div-cream">
                          <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(inventory[4], 'inv'), 'background-color': '#F2D1B7'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[4], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[4], 'low')}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-3 mb-3">
				<div class="row justify-content-center">
					<h5 >COCCONUT</h5>
				</div>
				<div class="row">
					<div class="keg-container-cream mx-auto">
                        <img class="keg-img-cream" src="../../../../../assets/media/vendi/Canister_creamer_bg_1.png"/>
                        <p class="keg-lbl-cream text-center">{{calcInvLvl(inventory[5], 'inv')}}</p>
                        <div class="flip keg-div-cream">
                          <div id="keg-fill-cream" [ngStyle]="{'height': calcInvLvl(inventory[5], 'inv'), 'background-color': '#EBEBEB'}"></div>
                        </div>
                    </div>
				</div>
				<div class="row text-center">
					<div class="col">
						<div class="row mb-3">
							<mat-icon style="cursor: pointer" class="text-primary mx-auto">edit</mat-icon>
						</div>
						<div class="row text-danger">
							<p class="mx-auto">EMPTY: {{calcInvLvl(inventory[5], 'empty')}}</p>
						</div>
						<div class="row text-warning">
							<p class="mx-auto">LOW  : {{calcInvLvl(inventory[5], 'low')}}</p>
						</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</div>
